import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { tomoIncludes, tomos } from '../../data/landing';
export function Tomos() {
  return <section className="border-y border-line bg-surface px-5 py-16 md:py-24" data-id="element-260" data-mp="7xcqk68gnybx">
      <div className="mx-auto max-w-6xl" data-id="element-261" data-mp="7zfe8jm55fdh">
        <div className="mx-auto max-w-3xl text-center" data-id="element-262" data-mp="cv4eyq9wd2bd">
          <TrophyIcon className="mx-auto h-10 w-10 text-success" aria-hidden="true" data-id="element-263" data-mp="cy0geokye94k" />
          <h2 className="mt-4 text-3xl font-black uppercase leading-[1.1] tracking-tight text-heading md:text-5xl" data-id="element-264" data-mp="3bfw92h1c7ptj">
            MegaPack <Highlight data-id="element-265" data-mp="3lc90175hzpkl">Dopamina Cero™</Highlight>
          </h2>
          <p className="mt-5 text-xl font-bold text-heading" data-id="element-266" data-mp="3lao53gf9u4m7">6 Tomos + 6 Bonos — Días 1 → 30</p>
          <p className="mt-1 text-lg text-body" data-id="element-267" data-mp="3qcdhaze8cobv">420+ páginas — Todo resuelto.</p>
        </div>

        <h3 className="mt-14 text-center text-sm font-bold uppercase tracking-[0.2em] text-success" style={{
        fontSize: "16px"
      }} data-id="element-268" data-mp="10l8lp6idti6l">
          6 Tomos completos
        </h3>

        <ol className="mt-8 space-y-4" data-id="element-269" data-mp="1hrh6wr4iy0pm">
          {tomos.map(t => <li key={t.number} className="grid grid-cols-[auto_1fr] items-center gap-5 rounded-3xl border border-line bg-ink p-5 md:grid-cols-[auto_260px_1fr] md:gap-8 md:p-6" data-id="element-270" data-mp="1ctxgksujxxhb">
              <span className="flex h-16 w-14 flex-col items-center justify-center rounded-lg text-white md:h-20 md:w-16" style={{
            backgroundColor: t.color
          }} aria-hidden="true" data-id="element-271" data-mp="18tx1d5zmpi97">
                <span className="text-[10px] font-bold uppercase tracking-wider opacity-90" data-id="element-272" data-mp="yvr3czgy0w9m">Tomo</span>
                <span className="text-2xl font-black leading-none md:text-3xl" data-id="element-273" data-mp="p433ca6bm6wj">{t.number}</span>
              </span>
              <div data-id="element-274" data-mp="l2rn2v9c6y10">
                <p className="text-sm font-bold uppercase tracking-wider text-body" data-id="element-275" data-mp="l3aw1mh0ec2w">
                  {t.days}
                </p>
                <p className="text-lg font-extrabold leading-tight text-heading md:text-xl" data-id="element-276" data-mp="g2n3gwd4tn6k">
                  {t.title}
                </p>
              </div>
              <p className="col-span-2 text-base text-body md:col-span-1" data-id="element-277" data-mp="1ggaql3656mc">{t.description}</p>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl border border-line bg-ink p-7 md:p-10" data-id="element-278" data-mp="6gkh3iad4kyu">
          <p className="text-xl font-extrabold text-heading" data-id="element-279" data-mp="3nozflb0i3z3o">Cada tomo incluye:</p>
          <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-280" data-mp="3smhgce4d780l">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base text-body" data-id="element-281" data-mp="k6nxvtqh3mgw">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success" data-id="element-282" data-mp="p6akuuw3sh2w">
                  <CheckIcon className="h-3.5 w-3.5 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-283" data-mp="ahxqu3gkt8b1" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}